// @flow

import styled from '@emotion/styled'
import * as React from 'react'

import { colors } from '@toggl/style'

import * as text from '../text'

export default function MenuContent({
  title,
  description,
  children,
}: {
  title: string,
  description: string,
  children?: React.Node,
}) {
  return (
    <StyledMenuHeader>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Content>{children}</Content>
    </StyledMenuHeader>
  )
}

const Content = styled.div`
  display: flex;
  margin-top: 20px;
`

const StyledMenuHeader: React.ComponentType<any> = styled.div`
  margin-bottom: 40px;

  & > h5 {
    margin-bottom: 4px;
  }

  & > span {
    letter-spacing: 0;
  }
`

const Title = styled.h5`
  ${text.heading4};
  color: ${colors.darkPurple};
`
const Description = styled.h5`
  ${text.paragraph3};
  color: ${colors.darkPurple};
`
